module.exports = __webpack_public_path__ + "static/img/apply-sick.7e9c5a76.png";